import * as React from 'react';
import { cn } from 'lib/utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  priority: number
};

export const PriorityIndicator = ({ className, priority, ...props }: Props) => {
  const text = `P${priority}`;

  return (
    <div
      {...props}
      className={cn(
      'flex items-center justify-center w-full max-w-[50px] h-5 rounded-sm text-white font-GilroyBold text-xs',
      priority === 1 && 'bg-red-600',
      priority === 2 && 'bg-orange-400',
      priority === 3 && 'bg-yellow-500',
      className,
    )}>
      {text}
    </div>
  );
};